module.exports = __webpack_public_path__ + "static/media/complaint-user-icon.98c23e7b.svg";